import { useState } from "react";
import { putMessagingSettings } from "../service";
import { message } from "antd";

function useMessagingSettings({ syncAssistant, workspaceId, assistantId }) {
  const [loading, setLoading] = useState(false);

  const updateMessagingSettings = async (payload) => {
    setLoading(true);
    message.loading("Updating settings");
    try {
      const response = await putMessagingSettings({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Settings Updated");
        setLoading(false);
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            messagingSettings: response.data,
          };
        });
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update settings");
      console.error("Error updating messaging settings", e);
    }
  };

  return { loading, setLoading, updateMessagingSettings };
}

export { useMessagingSettings };
